import { wsClient, WsRecvType, IWsHandler } from '../client'

type INotificationChangedData = {
    scope?: string
}

type INotificationChangedHandler = IWsHandler<INotificationChangedData>

const listeners: Array<() => void> = []

export function onNotificationChanged(callback: () => void) {
    listeners.push(callback)
    return () => {
        const index = listeners.indexOf(callback)
        if (index > -1) listeners.splice(index, 1)
    }
}

export default function () {
    wsClient.submitHandler(
        WsRecvType.NotificationChanged,
        ((packet) => {
            console.log('[WsClient] NotificationChanged', packet?.data)
            const scope = `${packet?.data?.scope ?? ''}`.trim()
            if (scope && scope !== 'notifications') return
            listeners.forEach(listener => listener())
        }) as INotificationChangedHandler,
    )
}
